import { faArrowRight, faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { isMobile, isMobileOnly } from 'react-device-detect';
import { Link, useHistory } from 'react-router-dom';
import styles from './Publications.module.css';
import { publicationPdfUrl, publicationThumbnailUrl } from './publicationFileUrl';
import { usePublications } from './usePublications';

export const Publications = () => {
  const history = useHistory();
  const { publications } = usePublications();
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      window.open(`${hash}`, '_self');
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div id="publications" className={styles.container}>
      <Link to="/" className={styles.homeIcon}>
        <FontAwesomeIcon icon={faHome} />
      </Link>
      <picture style={{ width: '100%' }}>
        <source
          srcSet={'/images/landingPage/publicationsBackground.webp'}
          type={'image/webp'}
        />
        <img
          src={'/images/landingPage/publicationsBackground.png'}
          alt="Publications Green Background"
          className={styles.backgroundImage}
        />
      </picture>
      <div className={styles.contentContainer}>
        <h1>Publications</h1>
        {isMobileOnly && <p>Scroll down for details on each publication</p>}
        <div
          className={
            !isMobileOnly
              ? styles.publicationsTop
              : styles.publicationsTopMobile
          }
        >
          {publications.map((pub) => (
            <div onClick={() => window.open(`#${pub.title}`, '_self')}>
              <img
                height={!isMobile ? '200px' : '150px'}
                src={publicationThumbnailUrl(pub.thumbnail)}
                alt="Decarbonised Electricity Report"
                className={styles.thumbnail}
              />
            </div>
          ))}
        </div>

        {publications.map((publication) => (
          <div id={publication.title} className={styles.publicationsList}>
            <div className={styles.imgContainer}>
              <img
                onClick={() => window.open(publicationPdfUrl(publication.url))}
                height="300px"
                src={publicationThumbnailUrl(publication.thumbnail)}
                alt="Decarbonised Electricity Report"
                className={styles.thumbnail}
              />
            </div>
            <div className={styles.textContainer}>
              <h2
                onClick={() => window.open(publicationPdfUrl(publication.url))}
              >
                {publication.title}
              </h2>

              {publication.description.split('\n').map((str) => (
                <p>{str}</p>
              ))}

              <h3
                className={styles.readMore}
                onClick={() =>
                  window.open(publicationPdfUrl(publication.url), '_blank')
                }
              >
                Read More{'  '}
                <FontAwesomeIcon className={styles.arrow} icon={faArrowRight} />
              </h3>
              {publication.secondaryLinkUrl && publication.secondaryLinkText && (
                <h3
                  className={styles.readMore}
                  onClick={() =>
                    publication.secondaryLinkUrl &&
                    history.push(publication.secondaryLinkUrl)
                  }
                >
                  {publication.secondaryLinkText}
                  {'  '}
                  <FontAwesomeIcon
                    className={styles.arrow}
                    icon={faArrowRight}
                  />
                </h3>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
